import { postJson, get, deleteApi } from "../../axios";

// 查询区间配置
export const querySectionConfig = (params) =>
  get(`/analysisConfig/get`, params);

// 保存区间配置
export const saveSectionConfig = (data) =>
  postJson(`/analysisConfig/save`, data);

// 查询标签列表
export const queryTagList = (params) =>
  get(`/yunzhou-common/getItemClassifyTagList`, params);

// 计量单位下拉查询
export const getQueryMeasureUnitList = (params) =>
  get(
    `/common/measure-unite/queryMeasureUnitList`,
    params,
  );

  // 周期配置
export const queryCycleConfig = (params) =>
  get(`/analysisConfig/get`, params);

  // 保存周期配置
export const saveCycleConfig = (data) =>
  postJson(`/analysisConfig/save`, data);


// 商品标签关联组查询
export const queryRelateTagGroupList = (data) =>
  postJson(`/bi-item-tag-relate-group/list`, data);

// 新增商品标签关联组
export const addRelateTagGroup = (data) =>
  postJson(`/bi-item-tag-relate-group/save`, data);

// 编辑商品标签关联组
export const editRelateTagGroup = (data) =>
  postJson(`/bi-item-tag-relate-group/update`, data);

// 删除商品标签关联组
export const deleteRelateTagGroup = (id) =>
  deleteApi(`/bi-item-tag-relate-group/delete/${id}`);
